<vault-my-folders>
  <app-header></app-header>
</vault-my-folders>
